// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./files/Industry-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./files/Industry-Book.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./files/Industry-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./files/Industry-Ultra.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Industry';
    font-style: normal;
    font-display: swap;
    font-weight: 200;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}

@font-face {
    font-family: 'Industry';
    font-style: normal;
    font-display: swap;
    font-weight: 300;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}

@font-face {
    font-family: 'Industry';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}

@font-face {
    font-family: 'Industry';
    font-style: normal;
    font-display: swap;
    font-weight: 600;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
}

@font-face {
    font-family: 'Industry';
    font-style: normal;
    font-display: swap;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
}

@font-face {
    font-family: 'Industry';
    font-style: normal;
    font-display: swap;
    font-weight: 900;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/industry/index.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAA2G;AAC/G;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAA2G;AAC/G;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAyG;AAC7G;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAyG;AAC7G;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAAyG;AAC7G;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAA2G;AAC/G","sourcesContent":["@font-face {\n    font-family: 'Industry';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 200;\n    src: url(./files/Industry-Light.otf) format('opentype'), url(./files/Industry-Light.otf) format('opentype');\n}\n\n@font-face {\n    font-family: 'Industry';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 300;\n    src: url(./files/Industry-Light.otf) format('opentype'), url(./files/Industry-Light.otf) format('opentype');\n}\n\n@font-face {\n    font-family: 'Industry';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 400;\n    src: url(./files/Industry-Book.otf) format('opentype'), url(./files/Industry-Book.otf) format('opentype');\n}\n\n@font-face {\n    font-family: 'Industry';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 600;\n    src: url(./files/Industry-Bold.otf) format('opentype'), url(./files/Industry-Bold.otf) format('opentype');\n}\n\n@font-face {\n    font-family: 'Industry';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 700;\n    src: url(./files/Industry-Bold.otf) format('opentype'), url(./files/Industry-Bold.otf) format('opentype');\n}\n\n@font-face {\n    font-family: 'Industry';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 900;\n    src: url(./files/Industry-Ultra.otf) format('opentype'), url(./files/Industry-Ultra.otf) format('opentype');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
